/**
 * @generated SignedSource<<2583747dee2962924573714df7e8ffba>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type appEconomic_viewer$data = {
  readonly id: string;
  readonly company: {
    readonly id: string;
    readonly economicEnabled: boolean | null;
  } | null;
  readonly " $fragmentType": "appEconomic_viewer";
};
export type appEconomic_viewer$key = {
  readonly " $data"?: appEconomic_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"appEconomic_viewer">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "appEconomic_viewer",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "Company",
      "kind": "LinkedField",
      "name": "company",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "economicEnabled",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};
})();

(node as any).hash = "a4025ea5d7b88f9725c5289139913851";

export default node;
